'use strict';

angular.module('docketbook').
  service('userService', function (accessControl, $http, $stateParams, $cookies, $q, Restangular, geolocation) {

    var userHasPermission = accessControl.userHasPermission;

    this.getUserConnections = function (successCb, failureCb) {
      const org = accessControl.currentOrg()
      if (!org) {
        return []
      }

      Restangular.all('user').all('connections').customGET().then(successCb, failureCb)
    }

    this.getUserInvitations = function (successCb, failureCb) {
      Restangular.all('user').all('connections').all('invitations').customGET().then(successCb, failureCb)
    }

    this.saveUserInvitation = function (invitation, successCb, failureCb) {
      Restangular.all('user').all('connections').all('invitations').one(invitation.id).customPUT({ status: invitation.status, organisationId: invitation.targetId }).then(successCb, failureCb)
    }

    /******* Create a New Organisation ********/
    this.createNewOrganisation = function (orgObj, successCb, failureCb) {
      Restangular.all('organisations').post(orgObj).then(successCb, failureCb);
    }

    /******* Get all members of an organisation ********/
    this.getMembers = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseMembers = Restangular.all("organisations").one(organisation.id).all('members');
      if (params == null) {
        params = {};
      }
      baseMembers.getList(params).then(successCb, failureCb);
    }

    /******* Get all members of an organisation group ********/
    this.getGroupMembers = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseMembers = Restangular.all("organisations").one(organisation.id);
      if (params.groupId != null) {
        baseMembers = baseMembers.all('groups').one(params.groupId).all('members');
      } else {
        baseMembers = baseMembers.all('groups').one(organisationGroup.id).all('members');
      }
      if (params == null) {
        params = {};
      }
      delete params.groupId;
      baseMembers.getList(params).then(successCb, failureCb);
    }

    /****** Get all email addresses of the org groups that the current user is a part of *****/
    this.getOrgEmailAddresses = function () {
      var organisations = accessControl.allowedOrganisations();
      var orgEmails = [];
      if (organisations != null) {
        for (var i = 0; i < organisations.length; i++) {
          for (var j = 0; j < organisations[i].groups.length; j++) {
            if (organisations[i].groups[j].emailAddresses != null) {
              for (var k = 0; k < organisations[i].groups[j].emailAddresses.length; k++) {
                orgEmails.push(organisations[i].groups[j].emailAddresses[k]);
              }
            }
          }
        }
      }

      return orgEmails;
    }

    /****** Get Organisation Full ******/
    this.getOrganisation = function (orgId, successCb, failureCb) {
      //var baseOrganisation = Restangular.all('organisations').one(orgId);
      //baseOrganisation.get().then(successCb, failureCb);

      Restangular.all('organisations').getList().then(orgs => successCb(orgs.filter(org => org.id == orgId)[0]), failureCb)
    }

    this.getOrgData = function (orgId, successCb, failureCb) {
      Restangular.all('organisations').one(orgId).customGET().then(successCb, failureCb);
    }

    this.getGroups = function (orgId, successCb, failureCb) {
      Restangular.all('organisations').one(orgId).all('groups').customGET().then(successCb, failureCb);
    }

    /****** Request Organisation Setup Support ******/
    this.requestSetupSupport = function (orgId, supportMethod, supportContact, successCb, failureCb) {
      var updatePayload = { supportRequested: true, supportMethod: supportMethod, supportContact: supportContact };
      var baseOrganisation = Restangular.all('organisations').one(orgId);
      baseOrganisation.customPUT(updatePayload).then(successCb, failureCb);
    }

    /****** Update Organisation ******/
    this.updateOrganisation = function (orgId, updatePayload, successCb, failureCb) {
      var baseOrganisation = Restangular.all('organisations').one(orgId);
      baseOrganisation.customPUT(updatePayload).then(successCb, failureCb);
    }

    /****** Get Org Logo ******/
    this.getOrganisationLogo = function (orgId, successCb, failureCb) {
      var baseOrganisation = Restangular.all('organisations').one(orgId).all('logo');
      baseOrganisation.customGET().then(successCb, failureCb);
    }

    /******* Get Org Group Full *******/
    this.getOrganisationGroup = function (orgGroupId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(orgGroupId + "?populate=true");

      baseOrgGroup.get().then(successCb, failureCb);
    }

    /******* Save Org Group ******/
    this.saveOrganisationGroup = function (orgGroup, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroups = Restangular.all('organisations').one(organisation.id).all('groups');

      if (orgGroup.id == null) {
        orgGroup.organisation = organisation.id;
        baseOrgGroups.post(orgGroup).then(successCb, failureCb);
      } else {
        baseOrgGroups.one(orgGroup.id).customPUT(orgGroup).then(successCb, failureCb);
      }
    }

    /****** Add Group Member ******/
    this.addMemberToGroup = function (groupId, member, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
      baseOrgGroup.all('members').post(member).then(successCb, failureCb);
    }

    var inviteMembersToGroup = function (groupId, invites, successCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);

      baseOrgGroup.all('users').all('add').customPUT(invites).then(function (success) {
        successCb();
        return;
      }, function (err) {
        console.error('could not bulk invite members', err);
        successCb();
        return;
      });
    }

    var inviteMembersToGroups = function (pos, groupIds, invitesByGroups, successCb) {
      if (pos >= groupIds.length) {
        successCb();
        return;
      }

      inviteMembersToGroup(groupIds[pos], invitesByGroups[groupIds[pos]], function () {
        inviteMembersToGroups(pos + 1, groupIds, invitesByGroups, successCb);
      });
    }

    this.assignMembersToOrg = function (invitesByGroups, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var groupsRequiringInvites = [];
      var allGroupIds = Object.keys(invitesByGroups);
      for (var i = 0; i < allGroupIds.length; i++) {
        if (invitesByGroups[allGroupIds[i]].length > 0) {
          groupsRequiringInvites.push(allGroupIds[i]);
        }
      }

      inviteMembersToGroups(0, groupsRequiringInvites, invitesByGroups, function () {
        successCb();
        return;
      });

      //var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
      //baseOrgGroup.all('users').all('add').customPUT(membersList).then(successCb, failureCb);
    }

    this.assignMembersToGroup = function (groupId, membersList, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
      baseOrgGroup.all('users').all('add').customPUT(membersList).then(successCb, failureCb);
    }

    /****** Remove Group Member Role ******/
    this.removeMemberRoleFromGroup = function (groupId, userId, roleId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
      baseOrgGroup.all('members').one(userId).all('role').one(roleId).remove().then(successCb, failureCb);
    }

    /****** Remove Group Member ******/
    this.removeMemberFromGroup = function (groupId, userId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
      baseOrgGroup.all('members').one(userId).remove().then(successCb, failureCb);
    }

    /****** Remove Group Owner *******/
    this.removeOwnerFromGroup = function (groupId, userId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);
      baseOrgGroup.all('owners').one(userId).remove().then(successCb, failureCb);
    }

    /****** Remove Group Monitor *******/
    this.removeMonitorFromGroup = function (groupId, userId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var baseOrgGroup = Restangular.all('organisations').one(organisation.id).all('groups').one(groupId);

      var putObj = [];
      var userRemove = { user: userId, roles: ['monitor'] };
      putObj.push(userRemove);

      baseOrgGroup.all('users').all('remove').customPUT(putObj).then(successCb, failureCb);
    }

    /****** Get Roles ******/
    this.getRoles = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseRoles = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('roles');

      if (params == null) {
        params = {};
      }

      baseRoles.getList(params).then(successCb, failureCb);
    }

    /******* Save Role ********/
    this.saveRole = function (role, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseRoles = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('roles');

      if (role.id == null) {
        role.organisation = organisation.id;
        baseRoles.post(role).then(successCb, failureCb);
      } else {
        baseRoles.one(role.id).customPUT(role).then(successCb, failureCb);
      }
    }

    var deleteRole = function (roleId, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var baseRoles = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('roles');

      if (roleId.id != null) {
        roleId = roleId.id;
      }

      baseRoles.one(roleId).remove().then(successCb, failureCb);
    }

    this.deleteRole = deleteRole;

    /******** Delete Bulk Roles ********/
    this.deleteBulkRoles = function (roles, successCb) {
      var failures = [];
      deleteRoles(roles, 0, failures, function (failuresFilled) {
        successCb(failuresFilled);
      });
    }

    var deleteRoles = function (list, index, failures, successCb) {
      if (index >= list.length) {
        successCb(failures);
        return;
      }

      deleteRole(list[index].id, function (success) {
        deleteRoles(list, index + 1, failures, successCb);
      }, function (err) {
        failures.push(list[index]);
        deleteRoles(list, index + 1, failures, successCb);
      });
    }

    /******* Get Permissions *******/
    this.getPermissions = function (params, successCb, failureCb) {
      var organisation = accessControl.currentOrg();
      var organisationGroup = accessControl.currentOrgGroup();
      var basePermissions = Restangular.all('organisations').one(organisation.id).all('groups').one(organisationGroup.id).all('permissions');

      if (params == null) {
        params = {};
      }

      basePermissions.getList(params).then(successCb, failureCb);
    }

    this.getPermissionsForOrg = function (organisationId, params, successCb, failureCb) {
      var organisationGroup = accessControl.currentOrgGroup();
      var basePermissions = Restangular.all('organisations').one(organisationId).all('groups').one(organisationGroup.id).all('permissions');

      if (params == null) {
        params = {};
      }

      basePermissions.getList(params).then(successCb, failureCb);
    }

    /********* GET GROUP DIFF ************/
    var getGroupDiff = function (original, modified, successCb) {
      if (modified.id == null) {
        successCb(1, modified);
        return;
      }

      var diffCount = 0;
      var diff = {};

      // Check basic fields
      var fields = ['name', 'publicName', 'prefix', 'orderPrefix', 'jobPrefix', 'invoicePrefix', 'docketPrefix', 'description',
        'inheritsPermissions', 'inheritsAddressBook', 'projectGroup', 'defaultTemplate', 'timezone', 'timeFormat', 'active'];

      for (var i = 0; i < fields.length; i++) {
        var fieldName = fields[i];

        if (!original[fieldName] && modified[fieldName]) {
          diffCount += 1;
          diff[fieldName] = modified[fieldName];
        } else if (original[fieldName] != null && modified[fieldName] != null && original[fieldName] != modified[fieldName]) {
          diffCount += 1;
          diff[fieldName] = modified[fieldName];
        }
      }

      if (!original.address && modified.address) {
        diffCount += 1;
        diff.address = modified.address;
      } else if (modified.address) {
        // Check address object
        var addressFields = ['num', 'streetNum', 'streetName', 'suburb', 'state', 'postCode', 'country'];
        var addressChanged = false;
        for (var i = 0; i < addressFields.length; i++) {
          var fieldName = addressFields[i];
          if (!original.address[fieldName] && modified.address[fieldName]) {
            addressChanged = true;
            break;
          } else if (original.address[fieldName] && modified.address[fieldName] && original.address[fieldName] != modified.address[fieldName]) {
            addressChanged = true;
            break;
          }
        }
        if (addressChanged) {
          diffCount += 1;
          diff.address = modified.address;
        }
      }

      diff.id = modified.id;
      successCb(diffCount, diff);
    }

    this.getGroupDiff = getGroupDiff;

    /********* GET ORG DIFF ************/
    var getOrgDiff = function (original, modified, successCb) {
      var diffCount = 0;
      var diff = {};

      // Check basic fields
      var fields = [];
      for (var i = 0; i < fields.length; i++) {
        var fieldName = fields[i];

        if (!original[fieldName] && modified[fieldName]) {
          diffCount += 1;
          diff[fieldName] = modified[fieldName];
        } else if (original[fieldName] != null && modified[fieldName] != null && original[fieldName] != modified[fieldName]) {
          diffCount += 1;
          diff[fieldName] = modified[fieldName];
        }
      }

      if (original.features && original.features.timesheets && modified.features && modified.features.timesheets) {
        if (modified.features.timesheets.enabled != original.features.timesheets.enabled) {
          diffCount += 1;
          diff.features = {};
          diff.features.timesheets = modified.features.timesheets;
        }
      }

      diff.id = modified.id;
      successCb(diffCount, diff);
    }

    this.getOrgDiff = getOrgDiff;

    /*** Get Task ***/
    this.getTaskStatus = function (taskId, successCb, failureCb) {
      var baseTasks = Restangular.all('tasks');
      baseTasks.one(taskId).get().then(successCb, failureCb);
    }

    /******************************/
    /**** Permission Checker ******/
    /******************************/
    // NB: apiPermission is array and is checking using an OR

    var permissionActions = {};
    /************************/
    /**** Order Actions *****/
    /************************/
    permissionActions['createOperatorDocket'] = {
      apiPermission: ['io.docketbook.ojdapi.createOperatorDocket']
    };
    permissionActions['reDraftOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      itemStatus: ['Sent', 'Rejected', 'Closed'],
      accessControl: ['creator', 'editor']
    };
    permissionActions['sendOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.sendOrder'],
      //orgPermission: 'isCustomer',
      itemStatus: ['Draft'],
      accessControl: ['creator']
      /*valueRules: [{
        field : 'customerContact',
        type : '!=',
        value : null
      }]*/
    };
    permissionActions['acceptOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.acceptOrder'],
      orgPermission: '!creator',
      itemStatus: ['Draft', 'Sent', 'Rejected']
    };
    permissionActions['orderIsReviewable'] = {
      orgPermission: '!creator',
      itemStatus: ['Sent'],
      accessControl: ['supplier']
    };
    permissionActions['rejectOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.rejectOrder'],
      orgPermission: '!creator',
      itemStatus: ['Sent'],
      accessControl: ['supplier', 'customer']
    };
    permissionActions['finishOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.closeOrder'],
      //orgPermission: 'isSupplier',
      itemStatus: ['Sent', 'Accepted', 'Draft'],
      accessControl: ['supplier', 'customer', 'editor']
    };
    permissionActions['editOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      //orgPermission: 'isSupplier',
      //itemStatus: ['Draft', 'Rejected'],
      editing: false,
      accessControl: ['editor', 'creator', 'supplier', 'customer']
    };
    permissionActions['deleteOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.deleteOrder'],
      itemStatus: ['Draft'],
      accessControl: ['creator']
    };
    permissionActions['saveOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder', 'io.docketbook.ojdapi.createOrder'],
      //orgPermission: 'isSupplier',
      //itemStatus: ['Draft', 'Rejected','New'],
      editing: true,
      accessControl: ['editor', 'creator', 'supplier', 'customer']
    };
    permissionActions['createOrder'] = {
      apiPermission: ['io.docketbook.ojdapi.createOrder']
    };
    permissionActions['changeOrderSupplier'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      orgPermission: 'isCustomer',
      itemStatus: ['Draft', 'New', 'Rejected'],
      editing: true
    };
    permissionActions['changeOrderCustomer'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      orgPermission: 'isSupplier',
      itemStatus: ['Draft', 'New', 'Rejected'],
      editing: true
    };
    permissionActions['editOrderCustomer'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      orgPermission: 'isSupplier',
      itemStatus: ['Draft', 'Sent', 'Accepted', 'New', 'Rejected'],
      editing: true
    };
    permissionActions['swapCustomerSupplier'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      itemStatus: ['New'],
      editing: true
    };
    permissionActions['viewOrderDocketTemplate'] = {
      orgPermission: 'isSupplier'
    };
    permissionActions['changeOrderDocketTemplate'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      itemStatus: ['New', 'Draft', 'Rejected', 'Sent', 'Accepted'],
      orgPermission: ['isSupplier'],
      editing: true,
      /*valueRules: [{
        field : 'lineItems',
        type : 'arrayempty'
      }]*/
    };
    permissionActions['editLineItem'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      itemStatus: ['New', 'Draft', 'Rejected', 'Sent', 'Accepted'],
      //orgPermission: ['isSupplier'],
      editing: true
    };
    permissionActions['removeLineItem'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      itemStatus: ['New', 'Draft'],
      //orgPermission: ['isSupplier'],
      editing: true
      //valueRules: [{
      //  field : 'dockets',
      //  type : 'arrayempty'
      //}]
    };
    permissionActions['addLineItem'] = {
      apiPermission: ['io.docketbook.ojdapi.updateOrder'],
      itemStatus: ['New', 'Draft', 'Rejected', 'Sent', 'Accepted'],
      //orgPermission: ['isSupplier'],
      editing: true
    };
    permissionActions['isOrderSupplier'] = {
      orgPermission: 'isSupplier'
    };
    permissionActions['isOrderCustomer'] = {
      orgPermission: 'isCustomer'
    };
    permissionActions['customerViewLineItemQty'] = {
      itemStatus: ['Accepted']
    };
    permissionActions['changeOrderLineResource'] = {
      orgPermission: 'isSupplier',
      editing: true
    };
    permissionActions['viewOrderJobs'] = {
      orgPermission: ['isSupplier']
    };
    permissionActions['viewOrderJobsTab'] = {
      apiPermission: ['io.docketbook.ojdapi.getJob']
    };
    permissionActions['addOrderJob'] = {
      apiPermission: ['io.docketbook.ojdapi.createJob'],
      orgPermission: ['isSupplier'],
      valueRules: [{
        field: 'status',
        type: '!=',
        value: 'New'
      }]
    };
    permissionActions['viewOrderDockets'] = {
      //orgPermission: ['isSupplier']
    };
    permissionActions['addOrderDocket'] = {
      apiPermission: ['io.docketbook.ojdapi.createDocket'],
      orgPermission: ['isSupplier'],
      valueRules: [{
        field: 'status',
        type: '!=',
        value: 'New'
      }]
    };
    permissionActions['editCustomerRefNo'] = {
      //itemStatus: ['New', 'Draft'],
      //orgPermission: ['isCustomer'],
      editing: true
    };
    permissionActions['editOrderNotes'] = {
      editing: true
    };
    permissionActions['editSupplierRefNo'] = {
      //itemStatus: ['New', 'Draft'],
      //orgPermission: ['isSupplier'],
      editing: true
    };
    permissionActions['editOrderNumber'] = {
      itemStatus: ['New', 'Draft'],
      editing: true
    };
    permissionActions['viewSupplierRefNo'] = {
      orgPermission: ['isSupplier']
    };
    permissionActions['viewCustomerRefNo'] = {
      orgPermission: ['isCustomer']
    };
    permissionActions['editOrderStartDate'] = {
      itemStatus: ['New', 'Draft', 'Sent', 'Accepted', 'Rejected'],
      editing: true
    };
    permissionActions['changeOrderStartDate'] = permissionActions['editOrderStartDate'];
    permissionActions['editOrderEndDate'] = {
      itemStatus: ['New', 'Draft', 'Sent', 'Accepted', 'Rejected'],
      editing: true
    };
    permissionActions['changeOrderEndDate'] = permissionActions['editOrderEndDate'];

    /***********************/
    /***** Job Actions *****/
    /***********************/
    permissionActions['acceptJob'] = {
      assigneeStatus: ['Assigned'],
      itemStatus: ['Sent'],
      accessControl: ['assignee']
    };
    permissionActions['rejectJob'] = {
      assigneeStatus: ['Assigned'],
      itemStatus: ['Sent'],
      accessControl: ['assignee']
    };
    permissionActions['finishJob'] = {
      assigneeStatus: ['Accepted'],
      itemStatus: ['Sent'],
      accessControl: ['assignee']
    };
    permissionActions['sendJob'] = {
      itemStatus: ['Draft', 'Closed'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor']
    };
    permissionActions['closeJob'] = {
      itemStatus: ['Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor']
    };
    permissionActions['deleteJob'] = {
      itemStatus: ['Draft'],
      apiPermission: ['io.docketbook.ojdapi.deleteJob'],
      accessControl: ['editor']
    };
    permissionActions['shareJob'] = {
      accessControl: ['viewer', 'editor', 'forwarder']
    };
    permissionActions['duplicateJob'] = {
      apiPermission: ['io.docketbook.ojdapi.createJob'],
      editing: false,
      //orgPermission: 'isSupplier',
      valueRules: [{
        field: 'status',
        type: '!=',
        value: 'New'
      }]
    };
    permissionActions['editJob'] = {
      itemStatus: ['Draft', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      editing: false,
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['canEditJob'] = {
      itemStatus: ['Draft', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['saveJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      editing: true
    };
    permissionActions['editJobDetails'] = {
      itemStatus: ['New', 'Draft', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      editing: true,
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['unassignUserFromJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor', 'forwarder'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['assignUserToJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor', 'forwarder'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['deleteLineItemFromJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true,
      editing: true,
      valueRules: [{
        field: 'dockets',
        type: 'arrayempty'
      }]
    };
    permissionActions['addLineItemToJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor'],
      editing: true,
      accessControlIgnoreOnNew: true
    };
    permissionActions['editLineItemJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor'],
      editing: true,
      accessControlIgnoreOnNew: true
    };
    permissionActions['createDocketFromJob'] = {
      //apiPermission: ['io.docketbook.ojdapi.createDocket'],
      apiPermissions: ['io.docketbook.ojdapi.createDocket', 'io.docketbook.ojdapi.editJob'],
      accessControl: ['editor'],
      itemStatus: ['Draft', 'Sent']
    };
    permissionActions['assigneeCreateDocketFromJob'] = {
      assigneeStatus: ['Accepted'],
      itemStatus: ['Sent']
    };
    permissionActions['createJob'] = {
      apiPermission: ['io.docketbook.ojdapi.createJob']
    };
    permissionActions['changeJobOrder'] = {
      itemStatus: ['New', 'Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      editing: true,
      valueRules: [{
        field: 'lineItems',
        type: 'arrayempty'
      }],
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['changeJobStartDate'] = {
      itemStatus: ['New', 'Draft', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      editing: true,
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['changeJobEndDate'] = {
      itemStatus: ['New', 'Draft', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      editing: true,
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['addCommentToJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor', 'assignee', 'forwarder'],
      accessControlIgnoreOnNew: true
    };
    permissionActions['removeCommentFromJob'] = {
      itemStatus: ['Draft', 'New', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateJob'],
      accessControl: ['editor'],
      accessControlIgnoreOnNew: true
    };

    /**************************/
    /***** Docket Actions *****/
    /**************************/
    permissionActions['sendDocket'] = {
      itemStatus: ['Draft', 'New'],
      apiPermission: ['io.docketbook.ojdapi.sendDocket'],
      //orgPermission: 'isSupplier',
      accessControl: ['editor', 'creator']
    };
    permissionActions['recallDocket'] = {
      itemStatus: ['Sent'],
      apiPermission: ['io.docketbook.ojdapi.recallDocket'],
      //orgPermission: 'isSupplier',
      accessControl: ['editor', 'creator']
    };
    permissionActions['approveDocket'] = {
      itemStatus: ['Sent'],
      apiPermission: ['io.docketbook.ojdapi.approveDocket'],
      //orgPermission: 'isCustomer',
      accessControl: ['approver']
    };
    permissionActions['captureCustomerSignatureFromCustomer'] = {
      itemStatus: ['Draft', 'Sent'],
      //apiPermission: ['io.docketbook.ojdapi.approveDocket'],
      //orgPermission: 'isCustomer',
      accessControl: ['approver']
    };
    permissionActions['acceptDocket'] = permissionActions['approveDocket'];
    permissionActions['acceptFileDocket'] = {
      itemStatus: ['Sent'],
      apiPermission: ['io.docketbook.ojdapi.acceptAndFileDockets'],
      //orgPermission: 'isCustomer',
      accessControl: ['approver']
    };
    permissionActions['rejectDocket'] = {
      itemStatus: ['Sent'],
      apiPermission: ['io.docketbook.ojdapi.rejectDocket'],
      //orgPermission: 'isCustomer',
      accessControl: ['approver']
    };
    permissionActions['reDraftDocket'] = {
      itemStatus: ['Rejected'],
      accessControl: ['editor'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket']
    };
    /*permissionActions['sendDocket'] = {
      itemStatus: ['Sent', 'Accepted'],
      //orgPermission: 'isSupplier',
      accessControl: ['editor']
    };*/
    permissionActions['downloadDocket'] = {
      itemStatus: ['Draft', 'Sent', 'Accepted']
    };
    permissionActions['deleteDocket'] = {
      itemStatus: ['Draft'],
      apiPermission: ['io.docketbook.ojdapi.deleteDocket'],
      accessControl: ['editor', 'creator']
    };
    permissionActions['editDocket'] = {
      itemStatus: ['Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: false,
      accessControl: ['editor']
    };
    permissionActions['saveDocket'] = {
      itemStatus: ['Draft', 'New'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true
    };
    permissionActions['createDocket'] = {
      apiPermission: ['io.docketbook.ojdapi.createDocket']
    };
    permissionActions['createAdhocDocket'] = {
      apiPermission: ['io.docketbook.ojdapi.createAdhocDocket']
    };
    permissionActions['fileDocket'] = {
      itemStatus: ['Accepted'],
      apiPermission: ['io.docketbook.ojdapi.fileDockets']
    };
    permissionActions['editAccessControlItem'] = {
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true,
      accessControl: ['editor']
    };
    permissionActions['addAccessControlItem'] = {
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true,
      accessControl: ['editor']
    };
    permissionActions['changeDocketCustomer'] = {
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      orgPermission: 'isSupplier',
      itemStatus: ['Draft', 'New'],
      editing: true,
      valueRules: [{
        field: 'orderRef',
        type: '==',
        value: null
      }]
    };
    permissionActions['changeDocketOrder'] = {
      itemStatus: ['New', 'Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket', 'io.docketbook.ojdapi.getOrder'],
      editing: true,
      valueRules: [{
        field: 'jobRef',
        type: '==',
        value: null
      }]
      /*
        field : 'resources',
        type : 'arrayempty',
        value: 1
      },*/
    };
    permissionActions['changeDocketJob'] = {
      itemStatus: ['New', 'Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket', 'io.docketbook.ojdapi.getJob'],
      editing: true,
      valueRules: [{
        field: 'resources',
        type: 'arrayempty',
        value: 1
      }]
    };
    permissionActions['changeDocketDate'] = {
      itemStatus: ['New', 'Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true
    };
    permissionActions['changeDocketTemplate'] = {
      itemStatus: ['New', 'Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true,
      valueRules: [{
        field: 'orderRef',
        type: '==',
        value: null
      },
      {
        field: 'resources',
        type: 'arrayempty'
      }]
    };
    permissionActions['captureSupplierSignature'] = {
      itemStatus: ['New', 'Draft'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true,
      valueRules: [{
        field: 'supplierSignatureAttachment',
        type: 'nullempty'
      },
      {
        field: 'supplierSignatureImage',
        type: 'nullempty'
      },
      {
        field: 'id',
        type: '!=',
        vaue: null
      }]
    };
    permissionActions['captureCustomerSignature'] = {
      itemStatus: ['New', 'Draft', 'Sent'],
      apiPermission: ['io.docketbook.ojdapi.updateDocket'],
      editing: true,
      valueRules: [{
        field: 'customerSignatureAttachment',
        type: 'nullempty'
      },
      {
        field: 'customerSignatureImage',
        type: 'nullempty'
      },
      {
        field: 'id',
        type: '!=',
        vaue: null
      }]
    };
    permissionActions['addDocketResource'] = {
      itemStatus: ['New', 'Draft'],
      editing: true,
      accessControl: ['editor']
    };
    permissionActions['editDocketInteraction'] = {
      itemStatus: ['New', 'Draft'],
      editing: true,
      accessControl: ['editor']
    };
    permissionActions['removeDocketInteraction'] = {
      itemStatus: ['New', 'Draft'],
      editing: true,
      accessControl: ['editor']
    };
    permissionActions['addDocketAttachment'] = {
      itemStatus: ['New', 'Draft']
    };
    permissionActions['removeDocketAttachment'] = {
      itemStatus: ['New', 'Draft']
    };
    permissionActions['createBatch'] = {
      apiPermission: ['io.docketbook.ojdapi.createDocket']
    };

    permissionActions['viewOrdersSummary'] = {
      apiPermission: ['io.docketbook.ojdapi.getOrder']
    };
    permissionActions['viewJobsSummary'] = {
      apiPermission: ['io.docketbook.ojdapi.getJob']
    };
    permissionActions['viewDocketsSummary'] = {
      apiPermission: ['io.docketbook.ojdapi.getDocket']
    };

    /****************/
    /**** Admin *****/
    /****************/

    permissionActions['viewOrgBilling'] = {
      apiPermission: ['global-administrator']
    };
    permissionActions['createOrgGroup'] = {
      isAdmin: true
    };
    permissionActions['viewCompanySettings'] = {
      apiPermission: ['io.docketbook.uoapi.viewOrganisationSettings']
    };
    permissionActions['viewGroupSettings'] = {
      apiPermission: ['io.docketbook.uoapi.viewOrganisationSettings']
    };
    permissionActions['acceptConnection'] = {
      apiPermission: ['io.docketbook.uoapi.acceptConnection']
    };
    permissionActions['deleteConnection'] = {
      apiPermission: ['io.docketbook.uoapi.deleteConnection']
    };
    permissionActions['createConnection'] = {
      apiPermission: ['io.docketbook.uoapi.createConnection']
    };
    permissionActions['getConnections'] = {
      apiPermission: ['io.docketbook.uoapi.getConnection']
    };

    this.userCanDoAction = function (actionName, itemEdit) {
      if (itemEdit == null) {
        itemEdit = {}
      }

      var currentOrg = accessControl.currentOrg();
      var currentOrgGroup = accessControl.currentOrgGroup();
      var currentUser = accessControl.currentUser();

      if (permissionActions[actionName] != null) {
        var permissionToCheck = permissionActions[actionName];
        // Check user has admin permission if requireed
        if (permissionToCheck.isAdmin == true) {
          var isAdmin = false;
          if (currentOrg && currentOrg.globalAdministrators.indexOf(currentUser.id) != -1) {
            isAdmin = true;
          }
          if (currentOrg && currentOrg.owners && currentOrg.owners.indexOf(currentUser.id) != -1) {
            isAdmin = true;
          }
          if (currentOrgGroup && currentOrgGroup.owners && currentOrgGroup.owners.indexOf(currentUser.id) != -1) {
            isAdmin = true;
          }
          if (!isAdmin) {
            return false;
          }
        }

        // Check user has api permission if required (apiPermission - OR)
        if (permissionToCheck.apiPermission) {
          var permissionFound = false;
          for (var i = 0; i < permissionToCheck.apiPermission.length; i++) {
            if (userHasPermission(permissionToCheck.apiPermission[i])) {
              permissionFound = true;
            }
          }
          if (!permissionFound) {
            return false;
          }
        }

        // Check user has all require api permissions (apiPermissions - AND)
        if (permissionToCheck.apiPermissions) {
          var hasAllPermissions = true;
          for (var i = 0; i < permissionToCheck.apiPermissions.length; i++) {
            if (!userHasPermission(permissionToCheck.apiPermissions[i])) {
              hasAllPermissions = false;
              break;
            }
          }

          if (!hasAllPermissions) {
            return false;
          }
        }

        // Check user assignee status
        if (permissionToCheck.assigneeStatus) {
          if (!itemEdit.userAssigneeData) {
            return false;
          }
          if (!(itemEdit.userAssigneeData && permissionToCheck.assigneeStatus.indexOf(itemEdit.userAssigneeData.status) != -1)) {
            return false;
          }
        }

        // Check user has org permission if required
        if (permissionToCheck.orgPermission && permissionToCheck.orgPermission == 'isSupplier') {
          // check if currentOrgGroup is the supplierContact
          var foundEmail = false;
          if (currentOrgGroup != null) {
            if (!itemEdit || !currentOrgGroup.emailAddresses || !itemEdit.supplierContact || !itemEdit.supplierContact.contactAddresses) {
              return false;
            }
            for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
              if (itemEdit.supplierContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
                foundEmail = true;
              }
            }
          }

          if (!foundEmail) {
            return false;
          }
        } else if (permissionToCheck.orgPermission && permissionToCheck.orgPermission == 'isCustomer') {
          // check if currentOrgGroup is the supplierContact
          var foundEmail = false;
          if (currentOrgGroup != null) {
            if (!itemEdit || !currentOrgGroup.emailAddresses || !itemEdit.customerContact || !itemEdit.customerContact.contactAddresses) {
              return false;
            }
            for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
              if (itemEdit.customerContact.contactAddresses[currentOrgGroup.emailAddresses[i]] != null) {
                foundEmail = true;
              }
            }
          }

          if (!foundEmail) {
            return false;
          }
        } else if (permissionToCheck.orgPermission && permissionToCheck.orgPermission == '!creator') {
          if (!itemEdit.accessControl) {
            return false;
          }

          var foundPermission = false;
          if (currentOrgGroup != null) {
            for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
              if (itemEdit.accessControl[currentOrgGroup.emailAddresses[i]] && itemEdit.accessControl[currentOrgGroup.emailAddresses[i]].indexOf('creator') != -1) {
                foundPermission = true;
                break;
              }
            }
          }

          if (foundPermission) {
            return false;
          }
        }

        // Check item status is ok
        if (permissionToCheck.itemStatus && itemEdit) {
          if (permissionToCheck.itemStatus.indexOf(itemEdit.status) == -1) {
            return false;
          }
        }

        // Check edit status
        if (permissionToCheck.editing != null) {
          if (!itemEdit) {
            return false;
          } else {
            if ((permissionToCheck.editing == true && !itemEdit.editing)) {
              return false;
            } else if (permissionToCheck.editing == false && itemEdit.editing) {
              return false;
            }
          }
        }

        // Check accessControl permissions
        if (permissionToCheck.accessControl && itemEdit && itemEdit.accessControl && currentOrgGroup) {
          if (permissionToCheck.accessControlIgnoreOnNew && permissionToCheck.accessControlIgnoreOnNew == true) {

          } else {
            // Check group emailAddresses
            var foundPermission = false;
            for (var i = 0; i < currentOrgGroup.emailAddresses.length; i++) {
              if (itemEdit.accessControl[currentOrgGroup.emailAddresses[i]] != null) {
                for (var j = 0; j < permissionToCheck.accessControl.length; j++) {
                  if (itemEdit.accessControl[currentOrgGroup.emailAddresses[i]].indexOf(permissionToCheck.accessControl[j]) != -1) {
                    foundPermission = true;
                    break;
                  }
                }
              }
            }

            currentOrgGroup.emailAddresses.some((address) => {
              if (address in itemEdit.accessControl) {
                permissionToCheck.accessControl.some((permission) => {
                  if (itemEdit.accessControl[address].indexOf(permission) !== -1) {
                    foundPermission = true;
                  }
                  return foundPermission;
                })
              }
              return foundPermission;
            });

            // Check currentUsers emailAddresses
            for (var i = 0; i < currentUser.emailAddresses.length; i++) {
              if (itemEdit.accessControl[currentUser.emailAddresses[i]] != null) {
                for (var j = 0; j < permissionToCheck.accessControl.length; j++) {
                  if (itemEdit.accessControl[currentUser.emailAddresses[i]].indexOf(permissionToCheck.accessControl[j]) != -1) {
                    foundPermission = true;
                    break;
                  }
                }
              }
            }

            if (!foundPermission) {
              return false;
            }
          }
        }

        // check valueRules permissions
        if (permissionToCheck.valueRules != null && itemEdit) {
          for (var i = 0; i < permissionToCheck.valueRules.length; i++) {
            var valueRule = permissionToCheck.valueRules[i];
            // do check on this rule now plx
            if (valueRule.type == '==') {
              if (itemEdit[valueRule.field] == valueRule.value) {
                // all is good
              } else {
                return false;
              }
            } else if (valueRule.type == '!=') {
              if (itemEdit[valueRule.field] != valueRule.value) {
                // all is good
              } else {
                return false;
              }
            } else if (valueRule.type == 'length>') {
              if (itemEdit[valueRule.field].length > valueRule.value) {
                // all is good
              } else {
                return false;
              }
            } else if (valueRule.type == 'length<') {
              if (itemEdit[valueRule.field].length < valueRule.value) {
                // all is good
              } else {
                return false;
              }
            } else if (valueRule.type == 'arrayempty') {
              if (itemEdit[valueRule.field] == null || itemEdit[valueRule.field].length <= 0) {
                // all is good - array doesnt exist or is empty
              } else {
                return false;
              }
            } else if (valueRule.type == 'nullempty') {
              if (itemEdit[valueRule.field] == null || itemEdit[valueRule.field] == '') {
                // all is good
              } else {
                return false;
              }
            }
          }
        }
        return true;
      } else {
        return false;
      }
    }
  });



// WEBPACK FOOTER //
// ./src/services/userService.js